module.exports = __webpack_public_path__ + "img/logoNagro.a7885782.png";